import { parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';
import { PhoneDto } from '../services/User/userService.dto';

const MIN_PHONE_LENGTH_WITH_PLUS_SIGN = 12;

class PhoneUtils {
  convertToPhoneDto(phoneNumber: string, includeAreaCode = true): PhoneDto | undefined {
    const parsedPhoneNumber = this.parseToPhoneNumber(phoneNumber);
    if (!parsedPhoneNumber) return undefined;
    const countryCode = parsedPhoneNumber.countryCallingCode;
    const areaCode = includeAreaCode ? parsedPhoneNumber.nationalNumber.substring(0, 3) : '';
    const number = includeAreaCode ? parsedPhoneNumber.nationalNumber.substring(3) : parsedPhoneNumber.nationalNumber;
    return { countryCode, areaCode, number };
  }

  convertToString = (phoneDto?: PhoneDto): string => {
    if (!phoneDto) return '';
    return `+${phoneDto.countryCode}${phoneDto.areaCode}${phoneDto.number}`;
  };

  formatStringPhoneNumber = (phoneNumber?: string): string => {
    const parsedPhoneNumber = this.parseToPhoneNumber(phoneNumber);
    return parsedPhoneNumber ? parsedPhoneNumber.formatInternational() : '';
  };

  convertToPhoneDisplayNumber(phone?: PhoneDto): string {
    return this.formatStringPhoneNumber(this.convertToString(phone));
  }

  parseToPhoneNumber(phoneNumber?: string): PhoneNumber | undefined {
    if (!phoneNumber) return undefined;
    const phoneNumberWithPlusSign = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
    try {
      return parsePhoneNumber(phoneNumberWithPlusSign);
    } catch (e) {
      return undefined;
    }
  }

  isValid(phoneNumber?: string): boolean {
    if (!phoneNumber) return false;
    return phoneNumber.length >= MIN_PHONE_LENGTH_WITH_PLUS_SIGN;
  }
}

export const phoneUtils = new PhoneUtils();
